import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";

export default {
  name: "Negotiation",
  components: {
    TableList,
    DateField
  },
  data() {
    return {
      pageName: 'Negociações',
      permissionIsAuthorize: 'Merchant',
      modalTitle: "",
      countFilter: 0,
      paymentMethods: [],
      itemList: [],
      today: new Date(),
      filter: this.DefaultFilter(),
      loading: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      window: {
        width: 0,
        height: 0
      },
    };
  },

  mounted() {
    this.loading = true;
    this.ListPaymentMethods();
    this.ListNegotiation();
  },

  computed:{
    totalItems(){
      return this.pagination != undefined ? this.pagination.TotalItems : this.itemList.length;
    }
  },

  methods: {
    DefineColor(ltn) {
      return this.today > new Date(ltn.DateNegotiation) && ltn.NegotiatedAmount > ltn.TransactionAmount ? "red" : "limegreen";
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListNegotiation();
    },

    ResetFilter() {
      this.filter = this.DefaultFilter();
      this.ListNegotiation();
    },

    DefaultFilter() {
      return {
        IdMerchant: null,
        NameMerchant: null,
        IdentityMerchant: null,

        CodePaymentMethod: null,

        CreatedDateIni: null,
        CreatedDateFin: null
      };
    },

    GetParamsNegotiation(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Merchant.Name": this.filter.NameMerchant,
        "Object.Merchant.Identity": this.filter.IdentityMerchant,

        "Object.PaymentMethod.Code": this.filter.CodePaymentMethod,

        "InitialDate": this.filter.CreatedDateIni,
        "EndDate": this.filter.CreatedDateFin
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ListNegotiation() {
      this.loading = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => {if (hasValue(value)) this.countFilter++});
      const params = this.GetParamsNegotiation();
      this.$store.dispatch("ListNegotiationWithTransaction", params)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loading = false));
    },

    GetReport() {
      this.loading = true;
      const params = this.GetParamsNegotiation(true);
      this.$store.dispatch("ReportNegotiation", params)
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loading = false;
          }, 1200);
        });
    },

    ListPaymentMethods() {
      this.$store.dispatch("ListPaymentMethod").then(response => {
        this.paymentMethods = response;
      });
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/Negotiation/Negotiation.js